document.addEventListener('DOMContentLoaded', function () {
  const tabSections = document.querySelectorAll('.prod_info_tab_main');
  if (!tabSections.length) return;

  tabSections.forEach(function (section) {
    const tabs = Array.from(section.querySelectorAll('.prod_info_tab_title_item'));
    const panels = Array.from(section.querySelectorAll('.prod_info_pannel_item'));

    if (!tabs.length || !panels.length) return;

    const enableReadMore = section.getAttribute('data-enable-read-more') !== 'false';
    const openText = section.getAttribute('data-read-more-open') || 'Read more';
    const closeText = section.getAttribute('data-read-more-close') || 'Read less';

    function getCollapsedHeight() {
      const isMobile = window.innerWidth <= 767;
      const attr = isMobile ? 'data-read-more-height-mobile' : 'data-read-more-height';
      const fallback = isMobile ? '240' : '280';
      return parseInt(section.getAttribute(attr) || fallback, 10);
    }

    function checkPanelReadMore(panel) {
      if (!enableReadMore) return;
      const wrap = panel.querySelector('.prod_info_expandable_wrap');
      const actionWrap = panel.querySelector('.prod_info_read_more_wrap');
      const btn = actionWrap ? actionWrap.querySelector('.prod_info_read_more_btn') : null;
      if (!wrap || !actionWrap || !btn) return;

      const collapsedHeight = getCollapsedHeight();
      const scrollHeight = wrap.scrollHeight;
      const threshold = collapsedHeight + 50;

      if (scrollHeight > threshold) {
        if (!wrap.classList.contains('is-expanded')) {
          wrap.classList.add('is-collapsed');
          wrap.style.maxHeight = collapsedHeight + 'px';
          actionWrap.style.display = 'flex';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          actionWrap.style.display = 'flex';
        }
      } else {
        wrap.classList.remove('is-collapsed', 'is-expanded');
        wrap.style.maxHeight = '';
        actionWrap.style.display = 'none';
      }
    }

    function setupReadMore(panel) {
      if (!enableReadMore) return;
      const wrap = panel.querySelector('.prod_info_expandable_wrap');
      const actionWrap = panel.querySelector('.prod_info_read_more_wrap');
      const btn = actionWrap ? actionWrap.querySelector('.prod_info_read_more_btn') : null;
      if (!wrap || !actionWrap || !btn || btn.getAttribute('data-readmore-bound') === 'true') return;

      btn.setAttribute('data-readmore-bound', 'true');
      const btnText = btn.querySelector('.prod_info_read_more_text');

      btn.addEventListener('click', function () {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        const collapsedHeight = getCollapsedHeight();

        if (isExpanded) {
          // Collapse
          const startHeight = wrap.scrollHeight;
          wrap.style.maxHeight = startHeight + 'px';
          // Force layout reflow before transitioning
          wrap.offsetHeight;
          wrap.classList.remove('is-expanded');
          wrap.classList.add('is-collapsed');
          wrap.style.maxHeight = collapsedHeight + 'px';

          btn.setAttribute('aria-expanded', 'false');
          if (btnText) btnText.textContent = openText;

          // Scroll user back to top of tab section if scrolled down
          const tabRect = section.getBoundingClientRect();
          if (tabRect.top < 0) {
            const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            section.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
          }
        } else {
          // Expand
          const targetHeight = wrap.scrollHeight;
          wrap.classList.remove('is-collapsed');
          wrap.classList.add('is-expanded');
          wrap.style.maxHeight = targetHeight + 'px';

          btn.setAttribute('aria-expanded', 'true');
          if (btnText) btnText.textContent = closeText;

          const onTransitionEnd = function (e) {
            if (e.target === wrap && e.propertyName === 'max-height') {
              wrap.removeEventListener('transitionend', onTransitionEnd);
              if (wrap.classList.contains('is-expanded')) {
                wrap.style.maxHeight = 'none';
              }
            }
          };
          wrap.addEventListener('transitionend', onTransitionEnd);
        }
      });
    }

    // Set up button event listeners for all panels
    panels.forEach(function (panel) {
      setupReadMore(panel);
    });

    let activeTab = tabs.find(tab => tab.classList.contains('active')) || tabs[0];
    
    function activateTab(tab) {
      const tabId = tab.getAttribute('data-tab-id');
      
      tabs.forEach(t => {
        const isSelected = t === tab;
        t.classList.toggle('active', isSelected);
        t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        t.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      panels.forEach(panel => {
        const isSelected = panel.getAttribute('data-tab-id') === tabId;
        panel.classList.toggle('is-active', isSelected);
        if (isSelected) {
          panel.removeAttribute('hidden');
          // Re-check read-more height now that panel is rendered in layout
          checkPanelReadMore(panel);
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    // Initialize active tab
    activateTab(activeTab);

    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        panels.forEach(function (panel) {
          if (!panel.hasAttribute('hidden')) {
            checkPanelReadMore(panel);
          }
        });
      }, 200);
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
      
      // Keyboard Navigation
      tab.addEventListener('keydown', function(e) {
        let newIndex = index;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          newIndex = (index + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabs.length - 1;
        } else {
          return;
        }
        
        e.preventDefault();
        tabs[newIndex].focus();
        activateTab(tabs[newIndex]);
      });
    });
  });
});
